import { appRouter } from 'services/router/router.service';
import { appRouteStates } from 'states/index';

/**
 * Registering a state builds its URL rule, which is what lets `urlService.match` resolve a URL back
 * to a state name. That has to work before `appRouter.start()`: the bootstrap redirect decides where
 * a deep link points while the router is still unstarted. Idempotent, so every consumer can call it.
 */
export const registerAppRouteStates = (): void => {
  appRouteStates.forEach(state => {
    if (state.name && !appRouter.stateRegistry.get(state.name)) {
      appRouter.stateRegistry.register(state);
    }
  });
};
